<template>
  <div>
    <div id="menu">
      <md-button
        class="md-icon-button"
        to="/"
      >
        <md-tooltip v-text="'Inicio'" />
        <md-icon v-text="'home'" />
      </md-button>
      <md-menu
        md-align-trigger
        v-if="tipo === 'administrativo'"
      >
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Citas'" />
          <md-icon v-text="'today'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/citas">Calendario de citas</md-menu-item>
          <md-menu-item :href="$http.options.root+'/archivos/formato-importar-citas.csv'">Formato para importar escuelas</md-menu-item>
          <md-menu-item to="/importar/citas">Importar escuelas</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-button
        v-else
        class="md-icon-button"
        to="/citas"
      >
        <md-tooltip v-text="'Citas'" />
        <md-icon v-text="'today'" />
      </md-button>
      <md-menu
        md-align-trigger
        v-if="tipo === 'administrativo'"
      >
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Escuelas'" />
          <md-icon v-text="'school'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/escuelas">Escuelas registradas</md-menu-item>
          <md-menu-item to="/escuela">Registrar escuela</md-menu-item>
          <md-menu-item :href="$http.options.root+'/archivos/formato-importar-escuelas.csv'">Formato para importar escuelas</md-menu-item>
          <md-menu-item :href="$http.options.root+'/archivos/claves-estados-municipios.csv'">Claves de estados y municipios</md-menu-item>
          <md-menu-item to="/importar/escuelas">Importar escuelas</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-button
        v-else
        class="md-icon-button"
        to="/escuelas"
      >
        <md-tooltip v-text="'Escuelas'" />
        <md-icon v-text="'school'" />
      </md-button>
      <md-menu
        md-align-trigger
        v-if="isOnline"
      >
        <md-button
          v-if="tipo==='administrativo'"
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Documentos legales'" />
          <md-icon v-text="'description'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/legales">Documentos legales registrados</md-menu-item>
          <md-menu-item to="/legal">Registrar documento legal</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu
        md-align-trigger
        v-if="$session.get('tipo') != 'otro'"
      >
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Pacientes'" />
          <md-icon v-text="'people_outline'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/pacientes">Pacientes registrados</md-menu-item>
          <md-menu-item to="/paciente">Registrar paciente</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu md-align-trigger>
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Reportes'" />
          <md-icon v-text="'insert_chart_outlined'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item
            :href="$http.options.root+'/reportes/pacientes?a='+$session.get('token')"
            target="_blank"
          >Pacientes registrados</md-menu-item>
          <md-menu-item
            v-if="$session.get('tipo') === 'administrativo'"
            :href="$http.options.root+'/reportes/pacientesPosibilidadCancer?a='+$session.get('token')"
            target="_blank"
          >Pacientes con posibilidad de cáncer</md-menu-item>
          <md-menu-item
            v-if="$session.get('tipo') === 'administrativo'"
            :href="$http.options.root+'/reportes/derechohabiencia?a='+$session.get('token')"
            target="_blank"
          >Derechohabiencia</md-menu-item>
          <md-menu-item
            v-if="$session.get('tipo') === 'administrativo'"
            :href="$http.options.root+'/fotos/descargar'"
            target="_blank"
          >Descargar todas las fotografías</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu
        md-align-trigger
        v-if="isOnline && tipo === 'administrativo'"
      >
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Usuarios'" />
          <md-icon v-text="'account_circle'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/usuarios">Usuarios registrados</md-menu-item>
          <md-menu-item to="/usuario">Registrar usuario</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu
        md-align-trigger
        v-if="isOnline && tipo === 'administrativo'"
      >
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-tooltip v-text="'Configuración'" />
          <md-icon v-text="'settings'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item to="/configuracion">Configuración</md-menu-item>
          <md-menu-item to="/categorias">Jurisdicciones</md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu md-align-trigger>
        <md-button
          class="md-icon-button"
          md-menu-trigger
        >
          <md-icon v-text="'more_vert'" />
        </md-button>
        <md-menu-content md-theme="dark">
          <md-menu-item
            @click="doSyncAll"
            v-if="isOnline"
          >
            <md-icon v-text="'sync'" />
            Sincronizar
          </md-menu-item>
          <md-menu-item href="http://fundacioncimachih.org/tamizaje/programa/tamizaje-x64.exe">
            <md-icon v-text="'download'" />
            Descargar
          </md-menu-item>
          <md-menu-item @click="showDialogCerrarSesion = true">
            <md-icon
              class="md-dense"
              v-text="'exit_to_app'"
            />
            Cerrar sesión
          </md-menu-item>

          <md-menu-item>
            <md-icon
              class="md-dense"
              v-text="'fiber_manual_record'"
            />
            v1.10.7</md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
    <md-dialog-confirm
      :md-active.sync="showDialogCerrarSesion"
      md-title="¿Estás seguro deseas cerrar sesión?"
      md-content="Al cerrar sesión se borrará todo el trabajo que haya sido realizado y no se ha sincronizado."
      md-confirm-text="Si, cerrar sesión"
      md-cancel-text="Cancelar"
      @md-cancel="showDialogCerrarSesion = false"
      @md-confirm="_cerrarSesion"
    />
  </div>
</template>
<script>
export default {
  name: "MenuList",
  data() {
    return {
      tipo: "medico",
      showDialogCerrarSesion: false
    };
  },
  methods: {
    _cerrarSesion() {
      this.$session.destroy();
      this.$router.push("/login");
    },
    _falloResponse(err) {
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    doSyncAll() {
      this.$emit("doSync", "true");
      this.$router.push("/");
      setTimeout(() => this.doTheSync(), 1500);
    },
    doTheSync() {
      this.$http
        .post(
          "sync",
          {
            escuelas: JSON.parse(localStorage.getItem("escuelas")),
            escuelas_contactos: JSON.parse(
              localStorage.getItem("escuelas_contactos")
            ),
            escuelas_citas: JSON.parse(localStorage.getItem("escuelas_citas")),
            pacientes: JSON.parse(localStorage.getItem("pacientes"))
          },
          {
            headers: {
              Token: this.$session.get("token")
            }
          }
        )
        .then(
          res => {
            this.$emit("doSync", "false");
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 201 && "data" in res.body) {
              console.dir("sync response");
              console.dir(res.body);
              localStorage.setItem(
                "categorias_escuelas",
                JSON.stringify(res.body.data.categorias_escuelas)
              );
              localStorage.setItem(
                "escuelas",
                JSON.stringify(res.body.data.escuelas)
              );
              localStorage.setItem(
                "escuelas_contactos",
                JSON.stringify(res.body.data.escuelas_contactos)
              );
              localStorage.setItem(
                "escuelas_citas",
                JSON.stringify(res.body.data.escuelas_citas)
              );
              localStorage.setItem(
                "pacientes",
                JSON.stringify(res.body.data.pacientes)
              );
            } else {
              this.$emit(
                "msg",
                "Sucedió un error durante la sincronización. Inténtelo de nuevo."
              );
            }
          },
          err => {
            this.$emit("doSync", "false");
            this._falloResponse(err);
          }
        );
    },
    _shouldShowDialog(a) {
      this.$emit("doSync", a);
    },
    _cerrar() {
      this.$emit("close", false);
    }
  },
  created() {
    this.tipo = this.$session.get("tipo");
  }
};
</script>